var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hideChildTable == false)?_c('div',{style:({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px'
    })},[_c('h4',{style:({ margin: 0 })},[_vm._v("Units")]),_c('b-button',{staticClass:"is-rounded",attrs:{"type":"is-primary"},on:{"click":_vm.addUnitGroupUnit}},[_vm._v(" Add Unit ")])],1):_vm._e(),_c('ModernTable',{attrs:{"height":"initial","condensed":"","columns":_vm.columns,"rows":_vm.rows,"useLoader":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }